import { Injectable } from '@angular/core';
import { Router, CanActivate,ActivatedRouteSnapshot } from '@angular/router';
import { Userservice } from './userservice';
//import decode from 'jwt-decode';
import { JwtHelper } from 'angular2-jwt';
@Injectable()
export class AuthguardService implements CanActivate {

  constructor(
    private router: Router,
    private userService: Userservice,
    private jwtHelper:JwtHelper
  ) {}

  canActivate(route:ActivatedRouteSnapshot): boolean {
    let currentUser: any;
    let token:string;
    const expectedRole: string[]  = route.data.expectedRole;



   

    if (localStorage.getItem('currentUser')!=null) {
        currentUser = localStorage.getItem('currentUser');
        token = this.getToken(currentUser)
    }
    else {
        currentUser = sessionStorage.getItem('currentUser');
        token = this.getToken(currentUser)
    }

    if (!token) {

        this.router.navigate(['/login']);
        return false;
    }
    else {
        const tokenPayload=this.jwtHelper.decodeToken(token);
        if (this.userService.isAuthenticated(token)) {
          //If expectedRoles are not available, anonyumous user can access the page
          if(expectedRole){
            if(expectedRole.indexOf(tokenPayload.role) != -1){

              return true;
            }else{

              this.router.navigate(['/login']);
              return false;
            }
          }else{

            return true;
          }
        }
    }
  }

  private getToken(currentUser): string{
    currentUser  = JSON.parse(currentUser);


    if(currentUser != null){
      return currentUser.token
    }else{
      return null;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/authguard.service.ts